<template>
  <div>
    <v-row justify="center">
      <v-icon class="mx-2" size="35">currency_exchange</v-icon>
      <span style="font-size: 20px">Cambio de moneda</span>
    </v-row>
    <v-row justify="center" class="mt-5 mb-2">
      <v-col cols="12" sm="2" md="2" class="pt-0 pb-0">
        <v-autocomplete
          dense
          outlined
          v-model="rangeSelected"
          :items="rangeTime"
          label="Rango"
          color="cyanText"
          item-text="text"
          item-value="value"
          @change="updateRange(rangeSelected)"
          required
        ></v-autocomplete>
      </v-col>
      <v-col
        v-show="rangeSelected == 7"
        cols="12"
        sm="2"
        md="2"
        class="pt-0 pb-0"
      >
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="10"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              dense
              outlined
              v-model="dateFormatDMY"
              label="Desde"
              prepend-inner-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        v-show="rangeSelected == 7"
        cols="12"
        sm="2"
        md="2"
        class="pt-0 pb-0"
      >
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              dense
              outlined
              v-model="date2FormatDMY"
              label="Hasta"
              prepend-inner-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="2" md="2" class="pt-0 pb-0">
        <v-autocomplete
          dense
          outlined
          item-text="name"
          item-value="id"
          v-model="filters.groups"
          :items="itemsGroups"
          label="Grupo de moneda"
          color="cyanText"
          @change="updateData()"
          required
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="money_exchange_computed"
          :loading="loading"
          sort-by="calories"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Monedas</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>  <v-btn @click="dialog=true" outlined color="primary" dark >
                                        <v-icon>add</v-icon> Nuevo cambio
                                    </v-btn>
                                    <v-col md="2">
                                      <v-autocomplete
                                           dense
                                           outlined
                                           v-model="currency_filer"
                                           :items="currencies_computed"
                                           label="Moneda"
                                           color="cyanText"
                                           item-text="text"
                                           item-value="value"
                                           required hide-details
                                         ></v-autocomplete>
                                    </v-col>
       
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5"
                    >Seguro que desea eliminar?</v-card-title
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete"
                      >Cancel</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                      >OK</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.effective_date`]="{ item }">
            <span>
              {{ getDate(item.effective_date) }}
            </span>
          </template>
          <template v-slot:[`item.default_currency_code`]="{ item }">
            <span>
              <country-flag
                :country="getFlag(item.default_currency_id)"
                size="small"
              />
              {{ item.default_currency_description }}
            </span>
            <v-icon>arrow_right_alt</v-icon>
          </template>
          <template v-slot:[`item.foreing_currency_code`]="{ item }">
            <span>
              <country-flag
                :country="getFlag(item.foreing_currency_id)"
                size="small"
              />
              {{ item.foreing_currency_description }}
            </span>
            <v-icon>arrow_right_alt</v-icon>
          </template>
          <template v-slot:[`item.value`]="{ item }">
            <span>
              <country-flag
                :country="getFlag(item.foreing_currency_id)"
                size="small"
              />
              {{ item.value }} {{ item.foreing_currency_code }}
            </span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
          <template v-slot:no-data> </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogAddChanges" max-width="1000px">
                                
                                <v-card>
                                    <v-card-title primary-title class="justify-center">
                                        <div>
                                            <span class="text-h5 ">{{ formTitle }}</span>
                                        </div>

                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row justify="center">
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-autocomplete dense outlined v-model="editedItem.currency_group_id"
                                                        :items="itemsGroups" label="Grupos de cambio" item-text="name"
                                                        item-value="id" color="cyanText" prepend-inner-icon="speaker_group"
                                                        required></v-autocomplete>

                                                </v-col>
                                                <v-col cols="12" sm="6" md="4">
                                                    <!-- <v-menu v-model="menus" :close-on-content-click="false"
                                                        :nudge-right="10" transition="scale-transition" offset-y
                                                        min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field dense outlined v-model="dateFormatDMY"
                                                                label="Fecha efectiva" prepend-inner-icon="mdi-calendar"
                                                                readonly v-bind="attrs" v-on="on"></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="editedItem.effective_date"
                                                            @input="menu = false"></v-date-picker>
                                                    </v-menu> -->

                                                </v-col>
                                            </v-row>
                                            <v-row justify="center">

                                                <v-col cols="12" sm="6" md="3">
                                                    <v-autocomplete dense outlined v-model="editedItem.default_currency_id"
                                                        :items="currencies" label="Moneda base" color="cyanText"
                                                        prepend-inner-icon="attach_money" required>
                                                        <template slot="item" slot-scope="{ item }">
                                                            <country-flag class="mr-1" :country='getFlag(item.value)'
                                                                size='small' />
                                                            {{ item.text }}
                                                        </template>
                                                    </v-autocomplete>

                                                </v-col>
                                                <v-col cols="12" sm="6" md="3">
                                                    <v-autocomplete dense outlined v-model="editedItem.foreing_currency_id"
                                                        :items="currencies" label="Moneda destino" color="cyanText"
                                                        prepend-inner-icon="attach_money" required>
                                                        <template slot="item" slot-scope="{ item }">
                                                            <country-flag class="mr-1" :country='getFlag(item.value)'
                                                                size='small' />
                                                            {{ item.text }}
                                                        </template>
                                                    </v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="3">
                                                    <v-text-field type="number" dense outlined v-model="editedItem.value"
                                                        label="Valor"></v-text-field>
                                                </v-col>

                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions class="justify-center">

                                        <v-btn color="red darken-1" text @click="close">
                                            Cancelar
                                        </v-btn>
                                        <v-btn color="blue darken-1" outlined @click="save" :loading="loading">
                                            Guardar
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog v-model="dialog" max-width="1000px" persistent>
           
                <v-card>
                  <v-card-title primary-title class="justify-center">
                    <div>
                      <span class="text-h5">{{ formTitle }}</span>
                    </div>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row justify="center">
                        <v-col cols="12" sm="6" md="4">
                          <v-autocomplete
                            dense
                            outlined
                            v-model="editedItem.currency_group_id"
                            :items="itemsGroups"
                            label="Grupos de cambio"
                            item-text="name"
                            item-value="id"
                            color="cyanText"
                            prepend-inner-icon="speaker_group"
                            required
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-menu
                            v-model="menus"
                            :close-on-content-click="false"
                            :nudge-right="10"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                outlined
                                v-model="dateFormatDMYDialog"
                                label="Fecha efectiva"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="editedItem.effective_date"
                              @input="menu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col md="1" align="end">
                          <country-flag
                            :country="getFlag(3)"
                            size="medium"
                          />                          
                        </v-col>
                        <v-col md="2" align="end">
                         <span > 
                              1 $USD equivale a 
                          </span>                     
                        </v-col>
                        <v-col md="1">
                          <v-icon>arrow_forward</v-icon>
                        </v-col>
                        <v-col md="3">
                          <v-text-field
                            type="number"
                            dense 
                            outlined hide-details
                            v-model="editedItem.value_dop"
                            label="VALOR EN DOP"
                          >
                            <template v-slot:append>
                              <country-flag
                                :country="getFlag(1)"
                                size="medium"
                              />
                            </template>
                          </v-text-field>
                        </v-col>
                        </v-row>
                           <v-row justify="center" align="center">
                        <v-col md="1" align="end">
                          <country-flag
                            :country="getFlag(3)"
                            size="medium"
                          />                          
                        </v-col>
                        <v-col md="2" align="end">
                         <span > 
                              1 $USD equivale a 
                          </span>                     
                        </v-col>
                        <v-col md="1">
                          <v-icon>arrow_forward</v-icon>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            type="number"
                            dense hide-details
                            outlined 
                            v-model="editedItem.value_htg"
                            label="VALOR EN HTG"
                          >
                            <template v-slot:append>
                              <country-flag
                                :country="getFlag(2)"
                                size="medium"
                              />
                            </template>
                          </v-text-field>
                        </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                        <v-col md="1" align="end">
                          <country-flag
                            :country="getFlag(3)"
                            size="medium"
                          />                          
                        </v-col>
                        <v-col md="2" align="end">
                         <span > 
                              1 $USD equivale a 
                          </span>                     
                        </v-col>
                        <v-col md="1">
                          <v-icon>arrow_forward</v-icon>
                        </v-col>
                        <v-col  md="3">
                          <v-text-field
                            type="number"
                            dense
                            outlined hide-details
                            v-model="editedItem.value_eur"
                            label="VALOR EN EUR"
                          >
                            <template v-slot:append>
                              <country-flag
                                :country="getFlag(4)"
                                size="medium"
                              />
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions class="justify-center">
                    <v-btn color="red darken-1" text @click="dialog = false">
                      Cancelar
                    </v-btn>
                    <v-btn color="blue darken-1" outlined @click="save" :loading="loading">
                      Guardar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data: () => ({
    rangeSelected: "",
    dates: moment().startOf("day").format("YYYY-MM-DD"),
    dialog: false,
    dialogAddChanges: false,
    menus: false,
    menu2: false,
    menu: false,
    date: moment().startOf("month").format("YYYY-MM-DD"),
    date2: moment().endOf("month").format("YYYY-MM-DD"),
    lastdata: "",
    loading: false,
    dialogDelete: false,
    itemsGroups: [],
    headers: [
      { text: "Fecha", value: "effective_date" },
      {
        text: "Grupo de cambio",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Moneda base", value: "default_currency_code" },
      { text: "Moneda destino", value: "foreing_currency_code" },
      { text: "Valor", value: "value" },
      { text: "Action", value: "actions" },
    ],
    money_exchange: [],
    currencies: [],
    currency_filer:0,
    editedIndex: -1,
    editedItem: {
      currency_group_id: null,
      foreing_currency_id: null,
      default_currency_id: 3,
      effective_date: moment()
        .startOf("week")
        .add(1, "days")
        .format("YYYY-MM-DD"),
      value: "",
      value_dop: "",
      value_htg: "",
      value_eur: "",
    },
    defaultItem: {
      currency_group_id: null,
      foreing_currency_id: null,
      default_currency_id: 3,
      effective_date: moment()
        .startOf("week")
        .add(1, "days")
        .format("YYYY-MM-DD"),
      value: "",
      value_dop: "",
      value_htg: "",
      value_eur: "",
    },
    filters: {
      groups: null,
      location: null,
      department_id: null,
      dateStart: moment().startOf("month").format("YYYY-MM-DD"),
      dateEnd: moment().endOf("month").format("YYYY-MM-DD"),
    },
    rangeTime: [
      { text: "Hoy", value: "1" },
      { text: "Este semana", value: "2" },
      { text: "Siguiente semana", value: "3" },
      { text: "Este mes", value: "4" },
      { text: "Ultimos 3 meses", value: "5" },
      { text: "Este año", value: "6" },
      { text: "Personalizado", value: "7" },
    ],
  }),

  computed: {
    dateFormatDMY() {
      return moment(this.date).format("DD/MM/YYYY");
    },
    date2FormatDMY() {
      return moment(this.date2).format("DD/MM/YYYY");
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo cambio" : "Editar cambio";
    },
    dateFormatDMYDialog() {
      return moment(this.editedItem.effective_date).format("DD/MM/YYYY");
    },
    money_exchange_computed(){
      let data = [];
          data = this.money_exchange.filter((element)=>element.default_currency_id===3);
      if(this.currency_filer>0){
          data = data.filter((element)=>element.foreing_currency_id==this.currency_filer)
      }
      return data;
    },
    currencies_computed(){
      let currencies = this.currencies;
      currencies.unshift({value:0,text:"TODAS"});
      return currencies
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    date(val, newVal) {
      this.filters.dateStart = val;
      if (this.rangeSelected == 7) {
        this.updateData();
      }
    },
    date2(val, newVal) {
      this.filters.dateEnd = val;
      if (this.rangeSelected == 7) {
        this.updateData();
      }
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      let resultGroup = await this.api_Get("transactions/group_money");

      this.itemsGroups = await resultGroup.json();
      let resultCurrencies = await this.api_Get("accounting/currencies");
      for (let item of await resultCurrencies.json()) {
        this.currencies.push({ text: item.description, value: item.id });
      }
      let week = this.rangeTime.filter((element) => element.value == 2);
      if (this.itemsGroups.length > 0) {
        this.filters.groups = this.itemsGroups[0].id;
      }
      this.rangeSelected = week[0];
      this.updateData();
    },

    async updateData() {
      this.loading = true;
      let filtro = "   WHERE  ";

      this.filters.groups != undefined
        ? (filtro += "currency_group_id=" + this.filters.groups + " AND ")
        : (filtro += "");

      filtro +=
        " effective_date::DATE BETWEEN '" +
        this.date +
        "' and '" +
        this.date2 +
        "' ";

      let resultInvoices = await this.api_Post("transactions/get_money", {
        filters: filtro,
      });

      this.money_exchange = await resultInvoices.json();
      this.loading = false;
    },
    updateRange(item) {
      if (item == 1) {
        this.date = moment().format("YYYY-MM-DD");
        this.date2 = moment().format("YYYY-MM-DD");
      }
      if (item == 2) {
        this.date = moment()
          .startOf("week")
          .add("days", 1)
          .format("YYYY-MM-DD");
        this.date2 = moment().endOf("week").add("days", 1).format("YYYY-MM-DD");
      }
      if (item == 3) {
        this.date = moment()
          .startOf("week")
          .add("days", 8)
          .format("YYYY-MM-DD");
        this.date2 = moment().endOf("week").add("days", 8).format("YYYY-MM-DD");
      }

      if (item == 4) {
        this.date = moment().startOf("month").format("YYYY-MM-DD");
        this.date2 = moment().endOf("month").format("YYYY-MM-DD");
      }

      if (item == 5) {
        // = moment().startOf("month").format("YYYY-MM-DD");
        const fechaEspecifica = moment();
        const fechaHace3Meses = fechaEspecifica.clone().subtract(3, "months");
        this.date = fechaHace3Meses.format("YYYY-MM-DD");
        this.date2 = moment().endOf("month").format("YYYY-MM-DD");
      }

      if (item == 6) {
        this.date = moment().startOf("year").format("YYYY-MM-DD");
        this.date2 = moment().endOf("year").format("YYYY-MM-DD");
      }
      this.filters.dateStart = this.date;
      this.filters.dateEnd = this.date2;

      if (this.rangeSelected != 7) {
        this.updateData();
      }
      // this.updateData();
    },
    getDate(item) {
      return moment(item).format("DD/MM/YYYY");
    },

    editItem(item) {
      this.editedIndex = this.money_exchange.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialogAddChanges = true;
    },

    deleteItem(item) {
      this.editedIndex = this.money_exchange.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      try {
        const response = this.api_Post(
          "transactions/delete_exchange",
          this.editedItem
        );

        const data = await response;

        if (data.status == 200) {
          this.$toast.success("Registro con exito!");
          this.changeBusiness(this.lastdata);
        } else {
          this.$toast.error("data.error");
        }
      } catch (err) {}
      this.closeDelete();
    },

    close() {
      this.dialogAddChanges = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    generateCurrencyConversions(
      usdToDop,
      usdToHtg,
      usdToEur,
      currency_group,
      effective_date
    ) {
    

      // Calcular las conversiones
      const dopToUsd = 1 / usdToDop;
      const htgToUsd = 1 / usdToHtg;
      const eurToUsd = 1 / usdToEur;
      const dopToHtg = usdToHtg / usdToDop;
      const htgToDop = usdToDop / usdToHtg;
      const dopToEur = usdToEur / usdToDop;
      const eurToDop = usdToDop / usdToEur;
      const htgToEur = usdToEur / usdToHtg;
      const eurToHtg = usdToHtg / usdToEur;

      // Crear los objetos de conversión
      const conversions = [
        {
          currency_group_id: currency_group,
          foreing_currency_id: 3, //  USD
          default_currency_id: 1, // DOP
          effective_date: effective_date,
          value: 1 / parseFloat(usdToDop),
        },
        {
          currency_group_id: currency_group,
          foreing_currency_id: 3, // USD
          default_currency_id: 2, //  HTG
          effective_date: effective_date,
          value: 1 / parseFloat(usdToHtg),
        },
        {
          currency_group_id: currency_group,
          foreing_currency_id: 3, // USD
          default_currency_id: 4, //  EUR
          effective_date: effective_date,
          value: 1 / parseFloat(usdToEur),
        },
        {
          currency_group_id: currency_group,
          foreing_currency_id: 1, //  DOP
          default_currency_id: 3, // USD
          effective_date: effective_date,
          value: usdToDop,
        },
        {
          currency_group_id: currency_group,
          foreing_currency_id: 2, // HTG
          default_currency_id: 3, //  USD
          effective_date: effective_date,
          value: parseFloat(usdToHtg),
        },
        {
          currency_group_id: currency_group,
          foreing_currency_id: 4, // EUR
          default_currency_id: 3, //  USD
          effective_date: effective_date,
          value: parseFloat(usdToEur),
        },
        {
          currency_group_id: currency_group,
          foreing_currency_id: 1, // DOP
          default_currency_id: 2, // HTG
          effective_date: effective_date,
          value: parseFloat(usdToDop) / parseFloat(usdToHtg),
        },
        {
          currency_group_id: currency_group,
          foreing_currency_id: 2, // HTG
          default_currency_id: 1, // DOP
          effective_date: effective_date,
          value: parseFloat(usdToHtg) / parseFloat(usdToDop),
        },
        {
          currency_group_id: currency_group,
          foreing_currency_id: 1, // DOP
          default_currency_id: 4, // EUR
          effective_date: effective_date,
          value: parseFloat(usdToDop) / parseFloat(usdToEur),
        },
        {
          currency_group_id: currency_group,
          foreing_currency_id: 4, // EUR
          default_currency_id: 1, // DOP
          effective_date: effective_date,
          value: parseFloat(usdToEur) / parseFloat(usdToDop),
        },
        {
          currency_group_id: currency_group,
          foreing_currency_id: 2, // HTG
          default_currency_id: 4, // EUR
          effective_date: effective_date,
          value: parseFloat(usdToHtg) / parseFloat(usdToEur),
        },
        {
          currency_group_id: currency_group,
          foreing_currency_id: 4, // EUR
          default_currency_id: 2, // HTG
          effective_date: effective_date,
          value: parseFloat(usdToEur) / parseFloat(usdToHtg),
        },
      ];

      return conversions;
    },
 async save() {
    this.loading = true;
    // Lógica para actualizar (Update): Se mantiene sin cambios
    if (this.editedIndex > -1) {
        if (this.editedItem.currency_group_id === null) {
            this.$toast.warning("Seleciona la un grupo");
            return;
        }
        if (this.editedItem.default_currency_id === null) {
            this.$toast.warning("Seleciona la mondeda base");
            return;
        }
        if (this.editedItem.foreing_currency_id === 0) {
            this.$toast.warning("Seleciona la moneda a convertir");
            return;
        }
        if (this.editedItem.value === "") {
            this.$toast.warning("Elige el monto a convertir");
            return;
        }
      
        try {
            const response = this.api_Put(
                "transactions/save_exchange",
                Object.assign(
                    this.money_exchange[this.editedIndex],
                    this.editedItem
                )
            );

            const data = await response;

            if (data.status == 200) {
                this.$toast.success("Actualizado con exito!");
                this.initialize();
            } else {
                this.$toast.error("data.error");
            }
        } catch (err) {
            this.$toast.error("Ocurrió un error en la actualización.");
        }
      
    } 
    // Lógica para crear nuevos registros (Insert): MODIFICADA para BULK
    else {
        // 1. Validación
        if (this.editedItem.currency_group_id === null) {
            this.$toast.warning("Seleciona la un grupo");
            return;
        }

        // 2. Generar todas las conversiones (incluyendo las inversas)
        const conversions = this.generateCurrencyConversions(
            this.editedItem.value_dop,
            this.editedItem.value_htg,
            this.editedItem.value_eur,
            this.editedItem.currency_group_id,
            this.editedItem.effective_date
        );

        // 3. Enviar TODAS las conversiones en un único objeto al endpoint.
        // El nuevo backend espera { exchanges: [...] }
        try {
            const payload = {
                exchanges: conversions // Contiene todos los objetos de conversión
            };
            
            // Un solo POST al endpoint, que ahora maneja la inserción masiva
            const response = this.api_Post("transactions/save_exchange", payload); 
            const data = await response;

            if (data.status == 200) {
                this.$toast.success("Tasas de cambio registradas con éxito!");
            } else {
                // El backend debería retornar un error consolidado en caso de fallo
                this.$toast.error(data.error || "Ocurrió un error al registrar las tasas de cambio.");
            }
        } catch (err) {
            // Manejo de error de conexión/servidor
            console.error("Error en la solicitud de bulk insert:", err);
            this.$toast.error("Error de conexión o servidor. No se pudieron registrar las tasas.");
        }
    }
    this.close();
    this.loading = false;
    this.updateData();
},

    async editSave() {
        const response = this.api_Put(
                        "transactions/save_exchange",
                        Object.assign(this.money_exchange[this.editedIndex], this.editedItem)
                    );

                    const data = await response;

                    if (data.status == 200) {
                        this.$toast.success("Actualizado con exito!");
                        this.initialize()
                    } else {
                        this.$toast.error("data.error");
                    }
      this.initialize();
      this.dialogAddChanges = false;
     
    },
  },
};
</script>

<style></style>